import Badge from '@mui/material/Badge';
import Skeleton from '@mui/material/Skeleton';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';

import { useProductCenterApi } from 'api';
import { releaseNoteNotificationQuery } from 'api/queries';
import { useAdobeTracking } from 'library/hooks/useAdobeTracking';
import {
	home_About,
	home_ReleaseNotes,
	home_Trainings,
} from 'main/routes/urls/RouteUrls';

import HomeFooterColumnContainer from './HomeFooterColumnContainer';
import HomeLink from './HomeLink';

const ExploreSection = () => {
	const { t } = useTranslation(['home']);
	const { api } = useProductCenterApi();
	const { trackApplicationInteraction } = useAdobeTracking();
	const { data, isLoading } = useQuery(releaseNoteNotificationQuery(api));

	const skeletonPlaceholder = (
		<Skeleton variant="text" width={200} height={30} animation="wave" />
	);

	return (
		<HomeFooterColumnContainer header={t('explore')}>
			{isLoading ? (
				<>
					{skeletonPlaceholder}
					{skeletonPlaceholder}
					{skeletonPlaceholder}
				</>
			) : (
				<>
					<HomeLink
						to={generatePath(home_About)}
						label={t('about-product-center')}
						onLinkClick={() =>
							void trackApplicationInteraction({
								action: 'click',
								stepName: 'HOME Explore',
								selectedOptions: [
									{ attribute: 'page', value: 'about' },
								],
							})
						}
					/>
					<HomeLink
						to={generatePath(home_Trainings)}
						label={t('traingins')}
						onLinkClick={() =>
							void trackApplicationInteraction({
								action: 'click',
								stepName: 'HOME Explore',
								selectedOptions: [
									{ attribute: 'page', value: 'trainings' },
								],
							})
						}
					/>
					<HomeLink
						to={generatePath(home_ReleaseNotes)}
						label={
							<Badge
								color="secondary"
								sx={{ paddingRight: 1 }}
								variant="dot"
								invisible={!data}>
								{t('release-notes')}
							</Badge>
						}
						onLinkClick={() =>
							void trackApplicationInteraction({
								action: 'click',
								stepName: 'HOME Explore',
								selectedOptions: [
									{
										attribute: 'page',
										value: 'releaseNotes',
									},
								],
							})
						}
					/>
				</>
			)}
		</HomeFooterColumnContainer>
	);
};

export default ExploreSection;
